/* eslint-disable unicorn/filename-case -- legacy Upload*.tsx naming */
import CloseIcon from "@mui/icons-material/Close";
import { DisplayImage } from "@/components/common/DisplayImage";
import { getDocumentUrl } from "@/utils/getData";
import PdfPreview from "../pdfPreview";
import type { UploadPreviewProps } from "./types";
import {
  HeaderBox,
  ImageContainer,
  StyledDialog,
  StyledDialogContent,
  StyledIconButton,
  StyledTypography,
} from "./UploadStyles/UploadPreviewStyles";

export function UploadPreview({ open, onClose, document, isImage }: UploadPreviewProps) {
  const src = getDocumentUrl(document);
  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <StyledDialogContent>
        {/* Header with close button and title */}
        <HeaderBox>
          <StyledTypography variant="subtitle1">
            {document?.label ?? document?.name ?? "Document Preview"}
          </StyledTypography>
          <StyledIconButton onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </StyledIconButton>
        </HeaderBox>

        {/* Image Container */}
        <ImageContainer>
          {isImage ? (
            <DisplayImage
              image={{ url: src }}
              alt={document?.label ?? document?.name ?? "Document"}
              sx={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                borderRadius: 1,
              }}
            />
          ) : (
            <PdfPreview url={src} />
          )}
        </ImageContainer>
      </StyledDialogContent>
    </StyledDialog>
  );
}
